import { render, staticRenderFns } from "./ChinaMobileCancelModal.vue?vue&type=template&id=dff7c32a&"
import script from "./ChinaMobileCancelModal.vue?vue&type=script&lang=js&"
export * from "./ChinaMobileCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports